import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

/**
 * @deprecated [fabric-deprecated] - Use CustomerAssessmentService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class CustomerAssessmentsConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	/**
	 * @deprecated [fabric-deprecated] - Use CustomerAssessmentService from app-account instead
	 */
	getCustomerAssessmentEndpoint(): string {
		return this.configService.get(
			(x) => x.common.customerAssessments!.endpoints?.getAssessmentEndpoint,
			"v1/customer-assessments"
		);
	}
	/**
	 * @deprecated [fabric-deprecated] - Use CustomerAssessmentService from app-account instead
	 */
	getIsCustomerAssessmentsEnabled(): boolean {
		return this.configService.get((x) => x.common.customerAssessments!.isEnabled, false);
	}
}
